
<div class="_relative _pb-5 _w-full">
    <ng-container>
        <div class="_overflow-hidden _relative expandable-content _pb-1" 
            [ngClass]="{ 
                'expanded' : isExpanded,
                '_invisible' : loading
            }" 
            [ngStyle]="{ height: contentIsLargerThanPreview ? previewSize : 'auto' }">
            <ng-content></ng-content>
            <div *ngIf="!isExpanded && contentIsLargerThanPreview" class="_mask-gradient-bottom-top _h-10 _w-full _top-auto _bottom-0"></div>
        </div>
        <div *ngIf="contentIsLargerThanPreview"
            class="_absolute _flex _justify-center _w-full"
            [ngStyle]="{ bottom: buttonBottomOffset }">
            <span class="_link _underline _text-sm" (click)="expandContentToggle()">{{ activeButtonLabel }}</span>
        </div>
    </ng-container>
</div>

